import Vue from 'vue';

import { MutationClass, SearchState } from '../../../models';

export class SetAttributesMutation implements MutationClass {

  public static execute(state: SearchState, payload: { attribute: string, data: any; }): void {
    Vue.set(state.data.attributes, payload.attribute, payload.data);
  }
}
